<template>
	<!-- 开通会员 -->
	<div class="wid-12">
		<!-- -->
		<div class="" style=""
			v-show="$route.meta.showFather && this.$route.fullPath =='/personal/member/activateMembership'">
			<div class="box-shadow pad-1 mb-16">
				<div class="flex-1 jus-bet">
					<div class="">
						<div class="flex-1 mb-8">
							<img src="../../../assets/myself/Framehui.png" alt="">
							<p class="hui">《会员权益与义务告知书》</p>
						</div>
						<p class="tishi">开通会员后，请下载告知书并加盖公章，在15日内完成上传</p>
					</div>
					<div class="download flex-1" @click="downLoad(content)">
						<img src="../../../assets/myself/xiazai.png" alt="">
						<p>下载</p>
					</div>
				</div>
			</div>
			<div class="box-shadow pad-1">
				<div class="flex-1 mb-24">
					<div class="left-icon"></div>
					<p class="record-1">我的会员</p>
				</div>
				<div>
					<div class="flex-1 mb-12">
						<p class="name1"><span style="color: red;">*</span>姓名</p>
						<el-input v-model="userInfo.name" placeholder="请输入您的姓名"></el-input>
					</div>
					<div class="flex-1 mb-12">
						<p class="name1"><span style="color: red;">*</span>地域</p>
						<el-cascader size="large" :options="options1" v-model="selectedOptions" @change="handleChange">
						</el-cascader>
						<!-- <el-input v-model="input" placeholder="请输入内容"></el-input> -->
					</div>
					<div class="flex-1 mb-12">
						<p class="name1"><span style="color: red;">*</span>单位</p>
						<el-input v-model="userInfo.workUnit" placeholder="请输入您的单位名称"></el-input>
					</div>
					<div class="flex-1 mb-12">
						<p class="name1"><span style="color: red;">*</span>单位性质</p>
						<el-select v-model="userInfo.workTypeId" placeholder="请选择您的单位性质">
							<el-option v-for="item in workTypes" :key="item.id" :label="item.name" :value="item.id">
							</el-option>
						</el-select>
					</div>
					<div class="flex-1 mb-12">
						<p class="name1"><span style="color: red;">*</span>职务</p>
						<el-input v-model="userInfo.duties" placeholder="请输入您的职务名称"></el-input>
					</div>
					<div class="flex-1">
						<p class="name1"><span style="color: red;">*</span>手机号码</p>
						<el-input v-model="userInfo.phone" placeholder="请输入您的手机号码"></el-input>
					</div>
				</div>
			</div>
			<div class="flex-1 jus-bet">
				<div></div>
				<div class="next" @click="detail">下一步</div>
				<div></div>
			</div>
		</div>
		<router-view></router-view>
	</div>
</template>

<script>
	import {
		regionData,
		CodeToText
	} from 'element-china-area-data';
	import {
		getTypes
	} from '@/api/expert/api.js';
	import {
		getInvoiceList,
		getAgreement
	} from '@/api/personal/api.js';
	import {
		getUpdateUser,
		getUser
	} from '@/api/api.js';
	export default {
		components: {},
		data() {
			return {
				options: [{
					value: '选项1',
					label: '黄金糕'
				}, {
					value: '选项2',
					label: '双皮奶'
				}, {
					value: '选项3',
					label: '蚵仔煎'
				}, {
					value: '选项4',
					label: '龙须面'
				}, {
					value: '选项5',
					label: '北京烤鸭'
				}],
				ruleForm: {
					name: '',
					loginName: '',
					phone: ''
				},
				options1: regionData,
				userInfo: {
					areaCode: '',
					cityCode: '',
					provinceCode: '',
					provinceName: '',
					cityName: '',
					areaName: '',
					name: '',
					workUnit: '',
					workTypeId: '',
					duties: '',
					phone: '',
				},
				selectedOptions: [],
				workTypes: [],
				docTitle: '',
				content: ''
			}

		},
		created() {
			this.userInfo = this.$store.state.activity.user;
			console.log(this.userInfo, '====')
			// this.selectedOptions[0] = this.userInfo.provinceCode;
			// this.selectedOptions[1] = this.userInfo.cityCode;
			// this.selectedOptions[2] = this.userInfo.areaCode;
			let provinceCode = this.userInfo.provinceCode ? this.userInfo.provinceCode.toString() : null;
			let cityCode = this.userInfo.cityCode ? this.userInfo.cityCode.toString() : null;
			let areaCode = this.userInfo.areaCode ? this.userInfo.areaCode.toString() : null;
			this.selectedOptions[0] = provinceCode;
			this.selectedOptions[1] = cityCode;
			this.selectedOptions[2] = areaCode;
		},
		mounted() {
			this.getDwxz();
			this.getInit();
			this.getUserData();
		},
		methods: {
			getUserData() {
				getUser().then(res => {
					if (res.code == 0) {
						this.userInfo = res.data ? res.data : this.userInfo;
					}
				})
			},
			getInit() {
				getAgreement({
					type: 3
				}).then(res => {
					console.log(res.data, '--')
					// this.docTitle = res.data.title;
					localStorage.setItem('docTitle', this.docTitle)
					this.content = res.data.content;
				})
			},
			getDwxz() {
				getTypes({
					type: 5
				}).then(res => {
					let arr = [];
					let list = res.data;
					list.forEach((item, index) => {
						arr.push({
							id: item.id,
							name: item.name,
						})
					})
					this.workTypes = arr;
				})
			},
			handleChange(selectedOptions) {
				// this.userInfo.provinceCode = value[0];
				// this.userInfo.cityCode = value[1];
				// this.userInfo.areaCode = value[2];
				const [provinceCode, cityCode, areaCode] = selectedOptions;
				let area = this.getCodeToText([provinceCode, cityCode, areaCode].join(','), [provinceCode, cityCode,
					areaCode
				])
				const areaArray = area.split('/');
				this.userInfo.provinceCode = provinceCode;
				this.userInfo.cityCode = cityCode;
				this.userInfo.areaCode = areaCode;
				this.userInfo.provinceName = areaArray[0];
				this.userInfo.cityName = areaArray[1],
				this.userInfo.areaName = areaArray[2];
				console.log(areaArray, 'areaArray')
				// console.log(this.userInfo.provinceCode,'this.userInfo.provinceCode')
			},
			getCodeToText(codeStr, codeArray) {
				if (null === codeStr && null === codeArray) {
					return null;
				} else if (null === codeArray) {
					codeArray = codeStr.split(",");
				}
				let area = "";
				switch (codeArray.length) {
					case 1:
						area += CodeToText[codeArray[0]];
						break;
					case 2:
						area += CodeToText[codeArray[0]] + "/" + CodeToText[codeArray[1]];
						break;
					case 3:
						area +=
							CodeToText[codeArray[0]] +
							"/" +
							CodeToText[codeArray[1]] +
							"/" +
							CodeToText[codeArray[2]];
						break;
					default:
						break;
				}
				return area;
			},
			detail() {
				if (!this.userInfo.name) return this.$message({
					message: '请输入姓名',
					type: 'warning'
				});
				if (!this.userInfo.provinceName || !this.userInfo.cityName || !this.userInfo.areaName ) return this.$message({
					message: '请选择地域',
					type: 'warning'
				});
				if (!this.userInfo.workUnit) return this.$message({
					message: '请输入单位',
					type: 'warning'
				});
				if (!this.userInfo.workTypeId) return this.$message({
					message: '请选择单位性质',
					type: 'warning'
				});
				if (!this.userInfo.duties) return this.$message({
					message: '请输入职务',
					type: 'warning'
				});
				if (!this.userInfo.phone) return this.$message({
					message: '请输入手机号码',
					type: 'warning'
				});
				let phone = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
				if (!phone.test(this.userInfo.phone)) return this.$message({
					message: '手机号码格式输入错误',
					type: 'warning'
				});
				this.userInfo.address = this.userInfo.provinceName + this.userInfo.cityName + this.userInfo.areaName;
				getUpdateUser(this.userInfo).then(res => {
					if (res.code == 0) {
						this.$router.push('/personal/member/details')
					}
				})
			},
			downLoad(content) {
				window.open(content, '_blank')
			}
			// downLoad(content) {
			//     const link = document.createElement('a');
			//     link.href = content;
			//     link.setAttribute('download', content);
			//     link.click();
			// }
		}
	}
</script>

<style>

</style>
<style scoped>
	.box-shadow {
		box-shadow: 2px 2px 8px 0px rgba(195, 219, 255, 0.25);
		border-radius: 8px 8px 8px 8px;
	}

	.pad-1 {
		padding: 32px 16px;
	}

	.flex-1 {
		display: flex;
		align-items: center;
	}

	.jus-bet {
		justify-content: space-between;
	}

	.left-icon {
		width: 6px;
		height: 20px;
		background: #3377FF;
		border-radius: 18px;
		margin-right: 10px;
	}

	.mb-24 {
		margin-bottom: 24px;
	}

	.mb-8 {
		margin-bottom: 8px;
	}

	.mb-16 {
		margin-bottom: 16px;
	}

	.tishi {
		color: #FF4E33 !important;
	}

	.download {
		background: #F0F5FF;
		border-radius: 41px 41px 41px 41px;
		color: #3377FF;
		padding: 8px 16px;
	}

	.download img {
		width: 18px;
		height: 19px;
		padding-right: 8px;
	}

	.hui {
		color: #222222;
		font-family: font5;
		font-size: 16px;
	}

	.record-1 {
		font-size: 20px;
		color: #222222;
		font-family: font5;
	}

	.name1 {
		width: 82px;
		white-space: nowrap;
		color: #222222;
		line-height: 22px;
		font-size: 14px;
		font-family: font3;
		padding-right: 16px;
		text-align: right;
	}

	/*   /deep/.el-cascader .el-input {
        border: none;
    } */
	/*    /deep/.el-cascader{
        border: 1px solid #DCDFE6;
    } */
	/deep/.el-input {
		width: 300px;
		/* border: 1px solid #DCDFE6; */
		border-radius: 4px 4px 4px 4px;
	}

	.mb-12 {
		margin-bottom: 0.75rem;
	}

	.next {
		background: #3377FF;
		border-radius: 4px 4px 4px 4px;
		font-size: 16px;
		color: #FFFFFF;
		font-family: font3;
		padding: 12px 66px;
		margin-top: 3rem;
	}
</style>